
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexj_451GCBuyt1q35nge5NhSq2AzWvo_s8eMu_45D8lQFKx54Meta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/index.vue?macro=true";
import { default as indexSnnR8mFehjzt_LHN1uHvqqeRUc4NmKvqnWgwY7tyl4oMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/index.vue?macro=true";
import { default as resultOgoRlOvRXMbGweobdK7_45cYVaKY6Pkyka0QPlc8wNIhoMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/result.vue?macro=true";
import { default as pq_45testQw5YnznAoJipF_zJk8cuFmq4VGeuT33byfGUC3lnM9wMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/pq-test.vue?macro=true";
import { default as pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest.vue?macro=true";
import { default as myTNz_45cYuIQdugQNbrp3fN0MvIK6FrYqi0XNGkJSijdu8Meta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/my.vue?macro=true";
import { default as loginlcHHqEmJtnm3uJxsJKIQTWY0DKZZODsZ0hn4dKmODj8Meta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/login.vue?macro=true";
import { default as chatrEJOE3A2JPhiwsMqSlh9wTk5Bf7D22OrcT1JyjoMLgEMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/chat.vue?macro=true";
import { default as _91type_93peVWvVPL2YPz4GdxLgTnDp93kdLnmzQt3KfzuUhR8KUMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/policy/[type].vue?macro=true";
import { default as indexpVZiTKBPs_dKQdsL8pZo6Q1lqKfd44NZ8Fq12LINti0Meta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/index.vue?macro=true";
import { default as perqb5J8Q7JzmhkPkger6PCqm1nuhOS5GiqZFhUQNIrJzboMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/perq.vue?macro=true";
import { default as drRodinKnbKsqdI3Lrz7_455NNGzT2wbYLbTmGoLIsTEOUqUDKDYMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/drRodin.vue?macro=true";
import { default as guardiannhc5YPgiZLnzZsmP5OFQlDDXRQJtWSJARsFyvUl84kesMeta } from "/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/guardiann.vue?macro=true";
export default [
  {
    name: "index___ko___default",
    path: "/",
    meta: indexj_451GCBuyt1q35nge5NhSq2AzWvo_s8eMu_45D8lQFKx54Meta || {},
    alias: ["/"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/index.vue")
  },
  {
    name: "index___ko",
    path: "/ko",
    meta: indexj_451GCBuyt1q35nge5NhSq2AzWvo_s8eMu_45D8lQFKx54Meta || {},
    alias: ["/ko"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/index.vue")
  },
  {
    name: "index___en",
    path: "/en",
    meta: indexj_451GCBuyt1q35nge5NhSq2AzWvo_s8eMu_45D8lQFKx54Meta || {},
    alias: ["/en"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/index.vue")
  },
  {
    name: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta?.name,
    path: "/pqtest",
    meta: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta || {},
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest.vue"),
    children: [
  {
    name: "pqtest___ko___default",
    path: "",
    meta: indexSnnR8mFehjzt_LHN1uHvqqeRUc4NmKvqnWgwY7tyl4oMeta || {},
    alias: ["/pqtest"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/index.vue")
  },
  {
    name: "pqtest-result___ko___default",
    path: "result",
    meta: resultOgoRlOvRXMbGweobdK7_45cYVaKY6Pkyka0QPlc8wNIhoMeta || {},
    alias: ["/pqtest/result"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/result.vue")
  },
  {
    name: "pqtest-pq-test___ko___default",
    path: "pq-test",
    meta: pq_45testQw5YnznAoJipF_zJk8cuFmq4VGeuT33byfGUC3lnM9wMeta || {},
    alias: ["/pqtest/pq-test"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/pq-test.vue")
  }
]
  },
  {
    name: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta?.name,
    path: "/ko/pqtest",
    meta: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta || {},
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest.vue"),
    children: [
  {
    name: "pqtest___ko",
    path: "",
    meta: indexSnnR8mFehjzt_LHN1uHvqqeRUc4NmKvqnWgwY7tyl4oMeta || {},
    alias: ["/ko/pqtest"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/index.vue")
  },
  {
    name: "pqtest-result___ko",
    path: "result",
    meta: resultOgoRlOvRXMbGweobdK7_45cYVaKY6Pkyka0QPlc8wNIhoMeta || {},
    alias: ["/ko/pqtest/result"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/result.vue")
  },
  {
    name: "pqtest-pq-test___ko",
    path: "pq-test",
    meta: pq_45testQw5YnznAoJipF_zJk8cuFmq4VGeuT33byfGUC3lnM9wMeta || {},
    alias: ["/ko/pqtest/pq-test"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/pq-test.vue")
  }
]
  },
  {
    name: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta?.name,
    path: "/en/pqtest",
    meta: pqtestYvLJSVN7XvJSgrXjjjU9gMEHZr9pS3E3dHkJJFrwWtsMeta || {},
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest.vue"),
    children: [
  {
    name: "pqtest___en",
    path: "",
    meta: indexSnnR8mFehjzt_LHN1uHvqqeRUc4NmKvqnWgwY7tyl4oMeta || {},
    alias: ["/en/pqtest"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/index.vue")
  },
  {
    name: "pqtest-result___en",
    path: "result",
    meta: resultOgoRlOvRXMbGweobdK7_45cYVaKY6Pkyka0QPlc8wNIhoMeta || {},
    alias: ["/en/pqtest/result"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/result.vue")
  },
  {
    name: "pqtest-pq-test___en",
    path: "pq-test",
    meta: pq_45testQw5YnznAoJipF_zJk8cuFmq4VGeuT33byfGUC3lnM9wMeta || {},
    alias: ["/en/pqtest/pq-test"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/pqtest/pq-test.vue")
  }
]
  },
  {
    name: "auth-my___ko___default",
    path: "/auth/my",
    meta: myTNz_45cYuIQdugQNbrp3fN0MvIK6FrYqi0XNGkJSijdu8Meta || {},
    alias: ["/auth/my"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/my.vue")
  },
  {
    name: "auth-my___ko",
    path: "/ko/auth/my",
    meta: myTNz_45cYuIQdugQNbrp3fN0MvIK6FrYqi0XNGkJSijdu8Meta || {},
    alias: ["/ko/auth/my"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/my.vue")
  },
  {
    name: "auth-my___en",
    path: "/en/auth/my",
    meta: myTNz_45cYuIQdugQNbrp3fN0MvIK6FrYqi0XNGkJSijdu8Meta || {},
    alias: ["/en/auth/my"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/my.vue")
  },
  {
    name: "auth-login___ko___default",
    path: "/auth/login",
    meta: loginlcHHqEmJtnm3uJxsJKIQTWY0DKZZODsZ0hn4dKmODj8Meta || {},
    alias: ["/auth/login"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/login.vue")
  },
  {
    name: "auth-login___ko",
    path: "/ko/auth/login",
    meta: loginlcHHqEmJtnm3uJxsJKIQTWY0DKZZODsZ0hn4dKmODj8Meta || {},
    alias: ["/ko/auth/login"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/login.vue")
  },
  {
    name: "auth-login___en",
    path: "/en/auth/login",
    meta: loginlcHHqEmJtnm3uJxsJKIQTWY0DKZZODsZ0hn4dKmODj8Meta || {},
    alias: ["/en/auth/login"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/auth/login.vue")
  },
  {
    name: "dr-rodin-chat___ko___default",
    path: "/dr-rodin/chat",
    meta: chatrEJOE3A2JPhiwsMqSlh9wTk5Bf7D22OrcT1JyjoMLgEMeta || {},
    alias: ["/dr-rodin/chat"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/chat.vue")
  },
  {
    name: "dr-rodin-chat___ko",
    path: "/ko/dr-rodin/chat",
    meta: chatrEJOE3A2JPhiwsMqSlh9wTk5Bf7D22OrcT1JyjoMLgEMeta || {},
    alias: ["/ko/dr-rodin/chat"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/chat.vue")
  },
  {
    name: "dr-rodin-chat___en",
    path: "/en/dr-rodin/chat",
    meta: chatrEJOE3A2JPhiwsMqSlh9wTk5Bf7D22OrcT1JyjoMLgEMeta || {},
    alias: ["/en/dr-rodin/chat"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/chat.vue")
  },
  {
    name: "policy-type___ko___default",
    path: "/policy/:type()",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/policy/[type].vue")
  },
  {
    name: "policy-type___ko",
    path: "/ko/policy/:type()",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/policy/[type].vue")
  },
  {
    name: "policy-type___en",
    path: "/en/policy/:type()",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/policy/[type].vue")
  },
  {
    name: "dr-rodin___ko___default",
    path: "/dr-rodin",
    meta: indexpVZiTKBPs_dKQdsL8pZo6Q1lqKfd44NZ8Fq12LINti0Meta || {},
    alias: ["/dr-rodin"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/index.vue")
  },
  {
    name: "dr-rodin___ko",
    path: "/ko/dr-rodin",
    meta: indexpVZiTKBPs_dKQdsL8pZo6Q1lqKfd44NZ8Fq12LINti0Meta || {},
    alias: ["/ko/dr-rodin"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/index.vue")
  },
  {
    name: "dr-rodin___en",
    path: "/en/dr-rodin",
    meta: indexpVZiTKBPs_dKQdsL8pZo6Q1lqKfd44NZ8Fq12LINti0Meta || {},
    alias: ["/en/dr-rodin"],
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/dr-rodin/index.vue")
  },
  {
    name: "introduction-perq___ko___default",
    path: "/introduction/perq",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/perq.vue")
  },
  {
    name: "introduction-perq___ko",
    path: "/ko/introduction/perq",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/perq.vue")
  },
  {
    name: "introduction-perq___en",
    path: "/en/introduction/perq",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/perq.vue")
  },
  {
    name: "introduction-drRodin___ko___default",
    path: "/introduction/drRodin",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/drRodin.vue")
  },
  {
    name: "introduction-drRodin___ko",
    path: "/ko/introduction/drRodin",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/drRodin.vue")
  },
  {
    name: "introduction-drRodin___en",
    path: "/en/introduction/drRodin",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/drRodin.vue")
  },
  {
    name: "introduction-guardiann___ko___default",
    path: "/introduction/guardiann",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/guardiann.vue")
  },
  {
    name: "introduction-guardiann___ko",
    path: "/ko/introduction/guardiann",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/guardiann.vue")
  },
  {
    name: "introduction-guardiann___en",
    path: "/en/introduction/guardiann",
    component: () => import("/home/runner/work/guardiann-homepage/guardiann-homepage/pages/introduction/guardiann.vue")
  }
]